var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex-part"},[_c('div',{staticClass:"flex-part-itemA"},[_c('epidemic-info')],1),_c('div',{staticClass:"flex-part-itemB"},[_c('epidemic-detail'),_c('v-gaps',{attrs:{"height":16}}),_c('warning')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }